import GroupIcon from "@mui/icons-material/Group";
import { Card } from "@mui/material";
import SuiAvatar from "components/SuiAvatar";
import SuiBox from "components/SuiBox";
import SuiButton from "components/SuiButton";
import SuiTypography from "components/SuiTypography";
import { Link, useNavigate } from "react-router-dom";
import BlogOptions from "./blogoptions";
import { Tag } from "antd";

export const BlogAvatorBox = ({ blog }) => {
  return (
    <Link to={`/social/blog?userid=${blog.owner_id}`} target="_self">
      <SuiBox
        className={`flex items-center px-3 py-2 transition duration-150 ease-in-out border-b border-gray-300 cursor-pointer focus:outline-none`}
      >
        {blog.metadata?.avatar != "" ? (
          <SuiAvatar
            src={blog.metadata?.avatar}
            alt="profile-image"
            variant="rounded"
            size="sm"
            shadow="sm"
            className="mr-2"
            bgColor="info"
          />
        ) : (
          <SuiAvatar
            alt="profile-image"
            variant="rounded"
            size="sm"
            shadow="sm"
            className="mr-2"
            bgColor="info"
          >
            <GroupIcon fontSize="medium" />
          </SuiAvatar>
        )}
        <div className="w-full pb-2">
          <div className="flex justify-between items-center">
            <SuiTypography variant="body1" className={`block ml-2 text-gray-600 font-bold`}>
              {blog.username}
            </SuiTypography>
          </div>
          <div className="flex justify-between">
            <SuiTypography
              className={`ml-2 text-gray-600`}
              variant="caption"
              textTransform="none"
              color="secondary"
              sx={{
                width: "100%",
                minHeight: "16px",
                overflow: "hidden",
                textOverflow: "ellipsis",
                display: "-webkit-box",
                WebkitLineClamp: "1",
                WebkitBoxOrient: "vertical",
              }}
            >
              {new Date(blog.timestamp).toDateString()}
            </SuiTypography>
          </div>
        </div>
      </SuiBox>
    </Link>
  );
};

export const BlogLabelButton = ({ label }) => {
  return (
    <Link to={`/social/blog?label=${label}`} target="_self">
      <Tag style={{ marginBottom: 2 }}>{label}</Tag>

      {/* <SuiButton
        sx={{ py: 0, px: 1, m: 0.5, fontSize: 12 }}
        size="small"
        variant="contained"
        color="dark"
      >
        {label}
      </SuiButton> */}
    </Link>
  );
};

const BlogCard = ({ blog, refreshParent }) => {
  // console.log('blog', blog)
  let navigate = useNavigate();
  let labels = blog?.labels || [];
  labels = labels.slice(0, 6);
  return (
    <Card className="h-full flex flex-column min-w-[220px]">
      <Link to={`/social/blog?viewblogid=${blog.id}`} target="_self">
        <SuiBox display="flex" alignItems="center" justifyContent="center">
          <SuiBox
            className="aspect-[3/2] w-full"
            display="flex"
            alignItems="center"
            position="center"
            minHeight="5rem"
            borderRadius="xl"
            sx={{
              backgroundImage: blog.mainimg
                ? `url(${blog.mainimg})`
                : ({ functions: { rgba, linearGradient }, palette: { gradients } }) =>
                    `${linearGradient(
                      rgba(gradients.secondary.main, 0.2),
                      rgba(gradients.secondary.state, 0.4)
                    )}`,
              backgroundSize: "cover",
              backgroundPosition: "50%",
              overflow: "hidden",
            }}
          />
        </SuiBox>
      </Link>
      <SuiBox className="ml-2 mr-2 mt-2 justify-between" display="flex" alignItems="start">
        <SuiBox>
          {labels.map((label) => {
            return <BlogLabelButton label={label} />;
          })}
        </SuiBox>
        <SuiBox mt={1}>{<BlogOptions blog={blog} refreshParent={refreshParent} />}</SuiBox>
      </SuiBox>
      <SuiTypography className="ml-3 mr-3 mt-2" variant="h6" fontWeight="medium">
        <Link style={{ color: "inherit" }} to={`/social/blog?viewblogid=${blog.id}`} target="_self">
          {blog.title}
        </Link>
      </SuiTypography>
      <SuiTypography
        className="grow ml-3 mr-3 mt-2"
        variant="body1"
        fontWeight="regular"
        color="text"
      >
        {blog.summary}
      </SuiTypography>
      <BlogAvatorBox blog={blog} />
    </Card>
  );
};

export default BlogCard;
